/* eslint-disable */
import gaAsync from "@/js/common/Domain/Service/gaAsync";
import { BONUS_MILES_OPERATORS } from '@fr/fsd/features/tourProduct/filterTourProducts';

let FilterCriteriaModel = Backbone.Epoxy.Model.extend({
	defaults: {
		sandBeach:false,
		pebbleBeach:false,
		children_animators: false,
		children_pool: false,
		children_waterslides: false,
		children_aquapark: false,
		children_seaEnter: false,
		children_childmenu: false,
		children_childBed: false,
		children_nanny: false,
		children_clubs: false,
		withKids:false,
		adultsOnly:false,
		forCouples:false,
		nearTheLift:false,

		firstLine:false,
		secondLine:false,
		thirdLine:false,

		beachOwner:false,

		airConditioner:false,
		nearTheBeach:false,
		nearTheCenter:false,
        lonelyMan: false,
        cashback: false,
		beachType: 0,
		minPrice: 6000,
		maxPrice: 10000000,

		best:false,
		better:false,
		good:false,
		satisfactorily:false,
		noScore:false,

		operators:[],
		wifi:false,
		wellness:false,
		pool:false,
		animation:false,
		familyRooms:false,
		diving:false,
		freeSafe:false,
		fitnessCenter:false,
		freeMiniBar:false,
		prepayments: [],
		renovations: [],
		skiEquipment:false,
		honeyMoon:false,
		waterSports:false,
		spaAndHealth:false,
		nightClub:false,
		personsWithDisabilities:false,
		noSmokingRooms:false,
		smokingRooms:false,

		ratingLocation: 0,
		ratingService: 0,
		ratingMeal: 0,
		//waterActivities
		openPool: false,
		closePool: false,
		heatedPool: false,
		seaPool: false,
		kidsPool: false,
		waterslides: false,
		aquapark: false,
		saunaBathHammam: false,
		jacuzzi: false,
		//end waterActivities
		freeCancellation: false,
        bonusMiles: false,
	},
	computeds:{
		allLines: {
			deps:['firstLine', 'secondLine', 'thirdLine'],
			get: function(firstLine, secondLine, thirdLine) {
				return !(firstLine || secondLine || thirdLine);
			},
			set:function() {
				this.set({
					firstLine:false,
					secondLine: false,
					thirdLine: false
				});
			}
		},
		allScore: {
			deps:['best', 'better', 'good','satisfactorily', 'noScore'],
			get: function(best, better, good, satisfactorily, noScore) {
				return !(best || better || good || satisfactorily || noScore);
			},
			set:function() {
			}
		},
		operatorChanged: function() {
			var operatorValue = this.get('operators');
			if (operatorValue) {
				gaAsync(function(){ga('send', 'event', 'Search_Form', 'Additionally', 'operators', {'nonInteraction': 1})});
			}
		},
		nearTheLiftChanged: function() {
			var nearTheLiftValue = this.get('nearTheLift');
			if (nearTheLiftValue) {
				gaAsync(function(){ga('send', 'event', 'Search_Form', 'Additionally', 'nearTheLift', {'nonInteraction': 1})});
			}
		},

        cashbackChanged: {
            deps: ['cashback'],
            get(cashbackValue) {
                if (!cashbackValue) return;

                gaAsync(() => {
                    ga('send', 'event', 'Search_Form', 'Additionally', 'cashback', {
                        nonInteraction: 1,
                    });
                });
            },
        },
		airConditionerChanged: function() {
			var airConditionerValue = this.get('airConditioner');
			if (airConditionerValue) {
				gaAsync(function(){ga('send', 'event', 'Search_Form', 'Additionally', 'airConditioner', {'nonInteraction': 1})});
			}
		},
		wifiChanged: function() {
			var wifiValue = this.get('wifi');
			if (wifiValue) {
				gaAsync(function(){ga('send', 'event', 'Search_Form', 'Additionally', 'wifi', {'nonInteraction': 1})});
			}
		},
        isBonusMilesDisabled: {
            deps: ['operators'],
            get: (operators) => operators.length > 0 && operators.some((operatorId) => !BONUS_MILES_OPERATORS.has(operatorId))
        },
	},
	clearFilters: function() {
		this.set(JSON.parse(JSON.stringify(this.defaults)), { initiator: 'clearFilter' });
	}
});

export default FilterCriteriaModel;
